// src/components/AddEnemyForm.js
import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { colors } from '../styles/colors';

const AddEnemyForm = ({ onEnemyAdded }) => {
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [gameId, setGameId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('enemies')
        .insert([{ name, type, game_id: gameId }])
        .select()
        .single();
      if (error) throw error;
      onEnemyAdded(data);
      setName('');
      setType('');
      setGameId('');
    } catch (err) {
      console.error('Error adding enemy:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form style={formStyle} onSubmit={handleSubmit}>
      <h3 style={titleStyle}>Add New Enemy</h3>
      <input
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        style={inputStyle}
      />
      <input
        placeholder="Type"
        value={type}
        onChange={(e) => setType(e.target.value)}
        required
        style={inputStyle}
      />
      <input
        placeholder="Game ID"
        value={gameId}
        onChange={(e) => setGameId(e.target.value)}
        required
        style={inputStyle}
      />
      <button
        type="submit"
        disabled={loading}
        style={{ ...buttonStyle, opacity: loading ? 0.7 : 1 }}
      >
        {loading ? 'Adding...' : 'Add Enemy'}
      </button>
    </form>
  );
};

// --- Styling ---
const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  backgroundColor: colors.background,
  padding: '1rem',
  borderRadius: '12px',
  boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
};
const titleStyle = { color: colors.primary, margin: 0 };
const inputStyle = {
  padding: '0.5rem 0.75rem',
  borderRadius: '8px',
  border: '1px solid #ccc',
  outline: 'none',
  fontSize: '0.95rem',
};
const buttonStyle = {
  padding: '0.6rem 1rem',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: colors.button,
  color: '#fff',
  fontWeight: 600,
};

export default AddEnemyForm;